import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {__} from "i18n-for-browser";
import ListButton from "./ListButton";
import BudgetSlider from "./StepThree/BudgetSlider";
import InputContainer from "./StepThree/InputContainer";
import BudgetCollaboration from "./StepThree/BudgetCollaboration";
import PopupTitle from "./PopupTitle";
import connect from "react-redux/es/connect/connect";
import PopUp from "./PopUp";
import { getSavedGlobas, getSavingsInterest } from "../../helpers/bankHelper";


class DebitCreditDialog extends Component {
  static propTypes = {
    renteTitle: PropTypes.string,
  };
  static defaultProps = {
    disableCancel: false,
    disableInFinalStep: false
  };
  constructor(props) {
    super(props);
    this.state = {
      showPopUp: false,
      showDropDown: false
    }
    this.onChange = this.onChange.bind(this);
    this.toggleConfirm = this.toggleConfirm.bind(this);
  }

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  onChange(key, value) {
    if(this.props.value.confirmed !== true) {
      if(Number.isInteger(value) && this.props.negativeCredit ) value = -value;
      const v = {...this.props.value, [key]: value};
      if(this.props.creditRate && !this.props.noInterest) {
        if(this.props.negativeCredit || this.props.roundUp) {
          v.interest = Math.ceil((v.amount || 0) * this.props.creditRate);
        } else {
          v.interest = Math.floor((v.amount || 0) * this.props.creditRate);
          const {gameState, gameStateInput} = this.props;
          const { debitCredit } = gameStateInput.myState;
          const savedGlobas = getSavedGlobas(gameState, {...debitCredit, stortenSpaargeld: v});
          if(savedGlobas > 0) {
            const renteValue = getSavingsInterest(gameState, {...debitCredit, stortenSpaargeld: v}, savedGlobas, this.props.creditRate);
            const renteFix = renteValue - Math.floor((this.props.currentValue || 0) * this.props.creditRate);
            // console.log('Initial interest: ', v.interest);
            // console.log('savedGlobas', savedGlobas);
            // console.log('Rentevalue: ', renteValue);
            // console.log('renteFix: ', renteFix);
            v.interest = renteFix;
          }
        }
      } else if(this.props.savedThisRound) {
        // const savedThisRound = (this.props.savedThisRound.amount === undefined ? {amount: 0, interest: 0} : this.props.savedThisRound); //5
        // const savedEarlier = this.props.currentValue - savedThisRound.amount; //5
        const wantToSave = parseInt(value, 10); //10
        v.interest = 0;

        //Note: old probably faulty code.
        // const amountFromCurrentSavings = -(savedEarlier - wantToSave); //5
        // if(amountFromCurrentSavings > 0) { // 5 > 0 = true
        //   const interestThisRound = savedThisRound.interest;
        //   const interestToRemovePercentage = amountFromCurrentSavings / savedThisRound.amount;
        //   const interestToRemove = Math.ceil(interestToRemovePercentage * interestThisRound);
        //   // console.log("interestToRemove", interestToRemove);
        //   v.interest += interestToRemove;
        // }
        // if(wantToSave > amountFromCurrentSavings) { //10 > 5 = true
        //   const amountFromPrevSavings = wantToSave - (amountFromCurrentSavings > 0 ? amountFromCurrentSavings : 0); //5
        //   const interestToRemoveFromPrevSavings = Math.ceil(amountFromPrevSavings * this.props.creditRate);
        //   // console.log("interestToRemoveFromPrevSavings", interestToRemoveFromPrevSavings, "amountFromPrevSavings", amountFromPrevSavings, "wantToSave", wantToSave);
        //   v.interest += interestToRemoveFromPrevSavings;
        // }

        const totalSaved = this.props.currentValue;
        const interestOnCurrentSavings = Math.floor((totalSaved || 0) * this.props.creditRate);

        const newTotalSaved = totalSaved - wantToSave;
        const interestOnNewSavings = Math.floor((newTotalSaved || 0) * this.props.creditRate);

        const interestToRemove = interestOnCurrentSavings - interestOnNewSavings;
        // console.log(interestToRemove);
        v.interest = interestToRemove;
      }
      if(v.interest === undefined || (v.interest < 0 && !this.props.savedThisRound) || isNaN(v.interest)){
        v.interest = 0
      }

      if(v.amount === undefined){
        v.amount = 0;
      }
      this.props.onChange(v);
    }
  }

  getValid(values) {
    let valid = true;

    if(Object.keys(values).length === 0 && values.constructor === Object){
      valid = false;
    }

    if(values.amount === 0 || values.amount === undefined){
      valid = false;
    }

    if(this.props.fromCountry || this.props.toCountry){
      if(values.otherCountry === undefined){
        valid = false;
      }
    }
    return valid;
  }

  toggleConfirm() {
    if(Object.keys(this.props.value).length === 0 && this.props.value.constructor === Object){
      return;
    }
    let prevVal = this.props.value.confirmed;
    prevVal = (prevVal === undefined ? false : prevVal);
    const v = {...this.props.value, confirmed: !prevVal, unread: true};
    this.props.onChange(v);
  }

  renderDetails() {
    const v = this.props.value;
    const s = this.state || {};
    const { props } = this;
    let {amount, interest, confirmed} = v;
    amount = amount || 0;

    if(!confirmed) {
      amount = amount > this.props.max && this.props.disableCancel !== true ? this.props.max : amount;
    }
    interest = interest || 0;
    if(this.props.negativeCredit) {
      amount = -amount;
      interest = -interest;
    }

    let renteTitle = this.props.renteTitle || `${__('sim_totale_rente')}`;
    renteTitle = renteTitle + ":";
    let currentValueTitle = (this.props.currentValueTitle ? this.props.currentValueTitle + ":" : false);
    let currentValue = false;
    if(!!currentValueTitle || this.props.currentValue){
      currentValue = (this.props.currentValue ? this.props.currentValue : 0);
    }

    let remainingTitle = (this.props.remainingTitle ? this.props.remainingTitle + ":" : false);
    let remaining = false;
    if(!!remainingTitle && currentValue !== false){
      if(this.props.value.confirmed === true) {
        remaining = currentValue;
      } else {
        remaining = currentValue - amount;
      }
    }

    let accumulativeTitle = (this.props.accumulativeTitle ? this.props.accumulativeTitle + ":" : false);
    let accumulative = false;
    if(!!accumulativeTitle && currentValue !== false){
      accumulative = currentValue + amount;
    }

    let sliderTitle = (this.props.sliderTitle ? this.props.sliderTitle : (__('sim_lening')));

    if(this.props.value.confirmed !== true && this.props.sliderTitleAppend) {
      sliderTitle = `${sliderTitle} ${this.props.sliderTitleAppend}`
    }

    if(this.props.value.confirmed && this.props.sliderTitle_confirmed !== undefined) {
      sliderTitle = this.props.sliderTitle_confirmed;
    }

    return (
      <div className={'content-container' + (s.showDropDown ? ' show' : '') + (props.value.confirmed ? ' disableInput' : '')}>
        <div className='content-container-background'></div>
        <PopupTitle popupId={this.props.id} tag={'h4'}/>
        {(currentValue || this.isNumeric(currentValue)) && currentValueTitle ?
          <div>
            <div className="currentValue-container">
              <p>{__(currentValueTitle)}</p>
              <div className="point-holder">
                <li>
                  <span title={currentValue}>{currentValue}</span>
                  <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                </li>
              </div>
            </div>
            <div className={'border-line'}/>
          </div>
          :null}

        <div className="slider">
          <p>{sliderTitle}:</p>
          <BudgetSlider
            role={this.props.user.role}
            customOnChange={this.onChange}
            onChangeKey="amount"
            min={0}
            max={this.props.max}
            value={amount}
            unit={__('sim_miljard')}/>
        </div>

        {remainingTitle ?
          <InputContainer
            role={this.props.user.role}
            onChangeKey="remaining"
            customOnChange={this.onChange}
            title={__(remainingTitle)}
            value={parseInt(remaining, 0) || 0}
            disabled={true}
            unit={__('sim_miljard')}/>
          :null}

        {accumulativeTitle && this.props.value.confirmed !== true ?
          <InputContainer
            role={this.props.user.role}
            onChangeKey="remaining"
            customOnChange={this.onChange}
            title={__(accumulativeTitle)}
            value={parseInt(accumulative, 0) || 0}
            disabled={true}
            unit={__('sim_miljard')}/>
          :null}

        {this.props.noInterest ? null :
          <InputContainer
            role={this.props.user.role}
            onChangeKey="interest"
            max={100}
            customOnChange={this.onChange}
            onFocus={(ev) => {
              ev.target.setAttribute('type', 'text');
              ev.target.setSelectionRange(0, String(ev.target.value).length);
              ev.target.setAttribute('type', 'number');
            }}
            title={__(renteTitle)}
            value={(this.props.renteValue !== undefined ? parseInt(this.props.renteValue, 0) : parseInt(interest, 0)) }
            disabled={!!this.props.creditRate}
            unit={__('sim_miljard')}/>
        }
        {this.props.fromCountry || this.props.toCountry ?
          <BudgetCollaboration
            single
            value={v.otherCountry || ""}
            onChangeKey="otherCountry"
            customOnChange={this.onChange}
            title={(this.props.fromCountry
              ? (this.props.disableCancel ? __('sim_geleend_van_land') : __('lenenVanLand'))
              : (this.props.confirmed ? this.props.toCountry : this.props.toCountry)) + ":"
            }
          /> : null}
        {(this.props.allowInput && !this.props.disableCancel) ?  (
          <Fragment>
            <div className={'border-line'}/>
            <button className={this.getValid(this.props.value) && !this.props.gameStateInput.preventInputChanges ? "" : "disabled"} onClick={this.toggleConfirm}>
              <span>{this.props.value.confirmed !== true ? __('sim_opslaan') : __('sim_annuleren')}</span>
            </button>
          </Fragment>
        ) : null}
      </div>
    )
  }

  renderDropdownOrPopup() {
    const s = this.state || {};
    const desktop = document.querySelector('#root').clientWidth >= 1240;

    if (s.showDropDown) {
      if (desktop) {
        return (
          <PopUp closePopUpClick={() => this.setState({showDropDown: false})} interactive={true} closePopUpCross={true}>
            { this.renderDetails() }
          </PopUp>
        )
      }
      return (
        <Fragment>
          { this.renderDetails() }
        </Fragment>
      );
    }
    return null;
  }

  render() {
    const s = this.state || {};
    const { props } = this;

    let bankDisable = false;
    if ((props.disableInFinalStep && props.gameState.currentRound === 4)) {
      bankDisable = true;
    }

    return (
      <div className={(props.value.confirmed !== true ? "" : 'disableInput') + (bankDisable ? ' bank-disable' : '' )}>
        <ListButton
          onClick={() => {
            if (!bankDisable) {
              this.setState({showDropDown: !s.showDropDown})
            }
          }}
          bgColor={'blue'}
          title={this.props.title}
          icon={this.props.icon}/>

        { this.renderDropdownOrPopup() }

      </div>
    );
  }
}

export default connect(state => state)(DebitCreditDialog);



// WEBPACK FOOTER //
// ./src/components/elements/DebitCreditDialog.js